import { OrganizationsActionType } from './enum';
import { OrganizationsAction, OrganizationState } from './interfaces';

export const initialState: OrganizationState = {
	allUsers: [],
	allUsersError: false,
	allUsersLoading: false,
	totalRecords: 0,
	allDepartments: [],
	allDepartmentsLoading: false,
	allDepartmentsError: false,
	allDesignations: [],
	allDesignationsLoading: false,
	allDesignationsError: false,
	autoSuggestManager: [],
	autoSuggestManagerError: false
};

export default (state = initialState, { type, payload }: OrganizationsAction): OrganizationState => {
	switch (type) {
		case OrganizationsActionType.FETCH_ALL_USERS:
			return {
				...state,
				allUsersError: {},
				allUsersLoading: true
			};

		case OrganizationsActionType.STORE_ALL_USERS:
			return {
				...state,
				allUsersLoading: false,
				allUsers: payload.usersList,
				totalRecords: payload.totalRecords
			};

		case OrganizationsActionType.ERROR_STORE_ALL_USERS:
			return {
				...state,
				allUsersError: payload.error,
				allUsersLoading: false
			};

		case OrganizationsActionType.FETCH_ALL_DEPARTMENTS:
			return {
				...state,
				allDepartmentsError: {},
				allDepartmentsLoading: true
			};

		case OrganizationsActionType.STORE_ALL_DEPARTMENTS:
			return {
				...state,
				allDepartmentsLoading: false,
				allDepartments: payload
			};

		case OrganizationsActionType.ERROR_STORE_ALL_DEPARTMENTS:
			return {
				...state,
				allDepartmentsError: payload.error,
				allDepartmentsLoading: false
			};

		case OrganizationsActionType.FETCH_ALL_DESIGNATIONS:
			return {
				...state,
				allDesignationsError: {},
				allDesignationsLoading: true
			};

		case OrganizationsActionType.STORE_ALL_DESIGNATIONS:
			return {
				...state,
				allDesignationsLoading: false,
				allDesignations: payload
			};

		case OrganizationsActionType.ERROR_STORE_ALL_DESIGNATIONS:
			return {
				...state,
				allDesignationsError: payload.error,
				allDesignationsLoading: false
			};

		case OrganizationsActionType.STORE_MANAGER_AUTOCOMPLETE: {
			return {
				...state,
				autoSuggestManager: payload.data
			};
		}

		case OrganizationsActionType.ERROR_MANAGER_AUTOCOMPLETE: {
			return {
				...state,
				autoSuggestManagerError: payload.error
			};
		}

		default:
			return state;
	}
};
